module.exports = __webpack_public_path__ + "img/background000.0b84741a.jpg";